import { useTranslation } from "react-i18next";
import { Badge } from "ui";

import { PartnershipTypeBadge } from "src/components/PartnershipTypeBadge";

interface PartnershipCellProps {
  type: "ONLINE" | "IN_PERSON" | "HYBRID";
  status: "ACTIVE" | "PENDING" | "INACTIVE";
}

const statusClassNames = {
  ACTIVE:
    "border-green-200 bg-green-50 text-green-700 dark:border-green-800 dark:bg-green-950 dark:text-green-300",
  PENDING:
    "border-yellow-200 bg-yellow-50 text-yellow-700 dark:border-yellow-800 dark:bg-yellow-950 dark:text-yellow-300",
  INACTIVE:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-800 dark:bg-red-950 dark:text-red-300",
} as const;

export function PartnershipCell(props: PartnershipCellProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <PartnershipTypeBadge type={props.type} />
      <Badge variant="outline" className={statusClassNames[props.status]}>
        {t(`partnershipStatus.${props.status}`)}
      </Badge>
    </div>
  );
}
